var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgAlertInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 18 18",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.71875 0C3.90386 0 0 3.90526 0 8.71875C0 13.5351 3.90386 17.4375 8.71875 17.4375C13.5336 17.4375 17.4375 13.5351 17.4375 8.71875C17.4375 3.90526 13.5336 0 8.71875 0ZM8.71875 3.86719C9.53423 3.86719 10.1953 4.52827 10.1953 5.34375C10.1953 6.15923 9.53423 6.82031 8.71875 6.82031C7.90327 6.82031 7.24219 6.15923 7.24219 5.34375C7.24219 4.52827 7.90327 3.86719 8.71875 3.86719ZM10.6875 12.7969C10.6875 13.0299 10.4986 13.2188 10.2656 13.2188H7.17188C6.93889 13.2188 6.75 13.0299 6.75 12.7969V11.9531C6.75 11.7201 6.93889 11.5312 7.17188 11.5312H7.59375V9.28125H7.17188C6.93889 9.28125 6.75 9.09236 6.75 8.85938V8.01562C6.75 7.78264 6.93889 7.59375 7.17188 7.59375H9.42188C9.65486 7.59375 9.84375 7.78264 9.84375 8.01562V11.5312H10.2656C10.4986 11.5312 10.6875 11.7201 10.6875 11.9531V12.7969Z"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlertInfo);
export default __webpack_public_path__ + "static/media/AlertInfo.f8d8bb21a660bae924137058fd00e4bd.svg";
export { ForwardRef as ReactComponent };